import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '@/services/apiGateway';

export function useData<T>(endpoint: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refetchKey, setRefetchKey] = useState(0);

  const refetch = useCallback(() => setRefetchKey((k) => k + 1), []);

  useEffect(() => {
    if (endpoint === null) return;

    setIsLoading(true);
    setError(null);

    apiFetch<T>(endpoint)
      .then((result) => {
        setData(result);
        setError(null);
      })
      .catch((err: unknown) => {
        // 404 = new user, no data yet — show empty state instead of an error banner
        if (err instanceof Error && err.message.includes('404')) {
          setData(null);
          setError(null);
        } else {
          setData(null);
          setError(err instanceof Error ? err.message : 'An unexpected error occurred');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [endpoint, refetchKey]);

  return { data, isLoading, error, refetch };
}
